import React, { useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    // If we are not on the home page, let the default anchor link behavior work
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      // Use native scrollIntoView so the browser handles dynamic layout
      // shifts (e.g. lazy-loaded images) and respects scroll-padding-top
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.history.pushState(null, '', `#${sectionId}`);
      setIsOpen(false);
    }
  };
  const scrollToTop = (e: React.MouseEvent) => {
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    window.history.pushState(null, '', window.location.pathname);
  };
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-242" data-mp="hht05b453haw">
      {/* Promo Bar */}
      <a href="/#contact" style={{
      backgroundColor: '#FFE81A'
    }} className="block w-full text-black text-center py-1.5 px-3 text-xs sm:text-sm md:text-base font-black uppercase tracking-wide leading-snug hover:brightness-110 transition-all cursor-pointer" data-id="element-243" data-mp="mfm7i7h6ihcr">
        🔥 Limited Time Only!{' '}
        <span className="text-base sm:text-lg md:text-xl" style={{
        color: '#C92121'
      }} data-id="element-244" data-mp="10eu894szpxj2">
          $50 OFF
        </span>{' '}
        Listed Price of Full Details &{' '}
        <span className="text-base sm:text-lg md:text-xl" style={{
        color: '#C92121'
      }} data-id="element-245" data-mp="1a686zad4atb5">
          $20 OFF
        </span>{' '}
        Wash &amp; Wax — Call Now!
      </a>

      <nav className="bg-black/95 backdrop-blur-sm border-b border-zinc-900" aria-label="Main navigation" data-id="element-246" data-mp="1k3ml33bkj60a">
        <div className="max-w-7xl mx-auto px-4" data-id="element-247" data-mp="uf7eeewnfcf8">
          <div className="flex items-center justify-between h-16" data-id="element-248" data-mp="udwamf37e4o4">
            {/* Logo */}
            <Link to="/" onClick={scrollToTop} className="text-lg sm:text-xl font-black uppercase tracking-tight whitespace-nowrap" aria-label="Mike's Pro Detail - Home" data-id="element-249" data-mp="piqlz8if2bwc">
              <span className="text-white" data-id="element-250" data-mp="zebln000j02x">Mike's</span>{' '}
              <span className="text-red-600" data-id="element-251" data-mp="1d68b0waaqvvm">Pro Detail</span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-4 xl:gap-6" data-id="element-252" data-mp="1886p83lhkigg">
              <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-253" data-mp="1n4ea764pxnws">
                Services
              </a>
              <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-254" data-mp="3ox2frm4u4nfq">
                About
              </a>
              <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-255" data-mp="1zfp2h44webku">
                Gallery
              </a>
              <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-256" data-mp="1uo6zkajbe0x8">
                Reviews
              </a>
              <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-257" data-mp="1kr2d09lk43fw">
                FAQ
              </a>
              <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-258" data-mp="1bpuqspwbet26">
                Contact Us
              </a>
              <a href="tel:8183819905" className="flex items-center gap-2 px-4 xl:px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-259" data-mp="160ujob7f7dsi">
                <Phone className="w-4 h-4 shrink-0" data-id="element-260" data-mp="x067lm1l7ni9" />
                <span className="text-base xl:text-2xl tracking-tight whitespace-nowrap" data-id="element-261" data-mp="wylapprsvsh8">
                  (818) 381-9905
                </span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden text-white p-2 -mr-2 shrink-0" aria-label="Toggle menu" data-id="element-262" data-mp="n435gg6qjovb">
              {isOpen ? <X className="w-6 h-6" data-id="element-263" data-mp="ddgu4y61xkif" /> : <Menu className="w-6 h-6" data-id="element-264" data-mp="dcys1kwpkc2l" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen && <div className="lg:hidden py-4 border-t border-zinc-900" data-id="element-265" data-mp="990q72g00n5u">
              <div className="flex flex-col gap-4" data-id="element-266" data-mp="4b7mcg26458q">
                <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-267" data-mp="3vhif7ox0xzoz">
                  Services
                </a>
                <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-268" data-mp="2fx9gakkoyf0c">
                  About
                </a>
                <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-269" data-mp="1s9rrmxwq3x1l">
                  Gallery
                </a>
                <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-270" data-mp="218mxu9zrp74w">
                  Reviews
                </a>
                <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-271" data-mp="1dkdh3mhev9km">
                  FAQ
                </a>
                <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-272" data-mp="2bvn6bspibfiv">
                  Contact Us
                </a>
                <a href="tel:8183819905" className="flex items-center justify-center gap-2 px-5 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-273" data-mp="1xwf6qypfm5e5">
                  <Phone className="w-4 h-4" data-id="element-274" data-mp="26xlm34gcha5t" />
                  <span className="text-base tracking-tight" data-id="element-275" data-mp="26v8udzksblfk">
                    (818) 381-9905
                  </span>
                </a>
              </div>
            </div>}
        </div>
      </nav>
    </header>;
}